import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityBeneficiariesOrdersRoutes: MenuInterface[] = [
    {
        code: 'NewSale',
        route: [
            {
                content: '$type/orders/new',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'Deliver',
        route: [
            {
                content: '$type/deliveries/deliver',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'OrderList',
        route: [
            {
                content: '$type/orders/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'Allocation',
        route: [
            {
                content: '$type/orders/assignments/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GroupAllocation',
        route: [
            {
                content: '$type/orders/assignments/new',
                focus: 'empty',
            }, 'content'
        ],
    },
];
